import React, { useState, useEffect } from 'react';
import QRCode from "qrcode";

const PreviewGalileo = ({ show, onHide, content, count = 1, scale }) => {
  const [qrCode, setQrCode] = useState("");

  // ============================================================
  // GENERATE QR CODE (links to Lerros HQ contact page)
  // ============================================================
  useEffect(() => {
    const generateQR = async () => {
      try {
        const qrData = "https://company.lerros.com/de/kontakt/zentrale";
        const qr = await QRCode.toDataURL(qrData, {
          width: 150,
          margin: 0,
          errorCorrectionLevel: "M",
        });
        setQrCode(qr);
      } catch (error) {
        console.error("QR Code generation error:", error);
        setQrCode("");
      }
    };
    generateQR();
  }, []);

  // ============================================================
  // DATA PREPARATION
  // ============================================================
  const header = [...(content?.header || [])];
  const TotalQtys = [...(content?.TotalQtys || [])];

  const qty = TotalQtys[TotalQtys.length - 1];

  header.pop();
  TotalQtys.pop();

  // Combine headers and quantities, excluding zeros
  const combinedData = [];
  for (let i = 0; i < Math.min(header.length, TotalQtys.length); i++) {
    const q = Number(TotalQtys[i]);
    if (q !== 0) {
      combinedData.push({ header: header[i], quantity: q });
    }
  }

  // Split into two rows of max 6 entries
  const headers1 = combinedData.slice(0, 6).map((item) => item.header);
  const quantities1 = combinedData.slice(0, 6).map((item) => item.quantity);
  const headers2 = combinedData.slice(6, 12).map((item) => item.header);
  const quantities2 = combinedData.slice(6, 12).map((item) => item.quantity);

  const tableHeader1 = headers1.map((dt) => `<td class="size_col">${dt}</td>`).join("");
  const tableHeader2 = headers2.map((dt) => `<td class="size_col">${dt}</td>`).join("");
  const tableData1 = quantities1.map((dt) => `<td class="size_col">${dt} </td>`).join("");
  const tableData2 = quantities2.map((dt) => `<td class="size_col">${dt} </td>`).join("");

  const carton_size = `${content?.length} X ${content?.width} X ${content?.height}`;

  // ============================================================
  // REUSABLE PIECES
  // ============================================================
  const qrBlock = `
    <div class="container_1_qr">
      <div class="qr-main">
        <div class="carton-id">${content?.carton_ID || ""}</div>
        <img src="${qrCode}" class="qr-code" alt="QR Code" />
      </div>
    </div>`;

  const dimRow = content?.DIM
    ? `<div class="container_1_main_line">
          <div id="container_1_left_side">DIM</div>
          <div id="container_1_middle_side">:</div>
          <div id="container_1_right_side">${content?.DIM || ""}</div>
        </div>`
    : "";

  const arrowSvg = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
      <path d="M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160l56 0 0 192-56 0c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4l-56 0 0-192 56 0c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"/>
    </svg>`;

  // Section A and D share the same detail box, only label & size text differ
  const detailBox = (label, sizeText) => `
    <div class="container_1_main">
      <div class="carton_no">${content?.SNO || ""} (${label})</div>
      <div class="container_1">
        <div class="container_1_main_line">
          <div id="container_1_left_side">GALILEO ART</div>
          <div id="container_1_middle_side">:</div>
          <div id="container_1_right_side">${content?.ArtNo || ""}</div>
        </div>
        <div class="container_1_main_line">
          <div id="container_1_left_side">COL. NO</div>
          <div id="container_1_middle_side">:</div>
          <div id="container_1_right_side">${content?.CLRS || "000"}</div>
        </div>
        ${dimRow}
        <div class="container_1_main_line">
          <div id="container_1_left_side">P.O. NO</div>
          <div id="container_1_middle_side">:</div>
          <div id="container_1_right_side">${content?.PO || ""}</div>
        </div>
        <div class="container_1_main_line">
          <div id="container_1_left_side">CARTON NO.</div>
          <div id="container_1_middle_side">:</div>
          <div id="container_1_right_side">${content?.SNO || ""}</div>
        </div>

        <div class="container_1_main_line_2">
          <table>
            <thead><tr>${tableHeader1}</tr></thead>
            <tr>${tableData1}</tr>
          </table>
        </div>
        <div class="container_1_main_line_2">
          <table>
            <thead><tr>${tableHeader2}</tr></thead>
            <tr>${tableData2}</tr>
          </table>
        </div>

        <div class="container_1_main_line">
          <div id="container_1_left_side">QUANTITY PCS</div>
          <div id="container_1_middle_side">:</div>
          <div id="container_1_right_side">${content ? qty : ""}</div>
        </div>
        <div class="container_1_main_line">
          <div id="container_1_left_side">NUMBER OF LOTS</div>
          <div id="container_1_middle_side">:</div>
          <div id="container_1_right_side">${content?.NoOfLots || ""}</div>
        </div>
        <div class="container_1_main_line">
          <div id="container_1_left_side">CUSTOMER</div>
          <div id="container_1_middle_side">:</div>
          <div id="container_1_right_side">GALILEO</div>
        </div>
      </div>
      <div class="third_size">${sizeText}</div>
    </div>`;

  // ============================================================
  // LABEL HTML
  // Each section: .main_heading-container
  //                 ├── box (+ size text below it)
  //                 └── .container_1_qr  (bottom aligned to box's bottom line)
  // ============================================================
  const tbl = `
    <div class="main_container">

      <!-- (A) -->
      <div class="main_heading-container">
        ${detailBox("A", "50cm")}
        ${qrBlock}
      </div>

      <!-- (B) -->
      <div class="main_heading-container">
        <div class="container_second">
          <div class="carton_no">${content?.SNO || ""} (B)</div>
          <div class="container_second_">
            <div class="second_left" style="margin-right: 20px">${arrowSvg}</div>
            <div class="second_middle">
              <span>STACK</span>
              <span>STAPELN</span>
            </div>
            <div class="second_left" style="margin-left: 20px">${arrowSvg}</div>
          </div>
          <div class="second_barcode">
            <div class="common-cell barcode-cell" id="barcode">${content?.svg || ""}</div>
          </div>
          <div class="third_size">40cm</div>
        </div>
        ${qrBlock}
      </div>

      <!-- (C) -->
      <div class="main_heading-container">
        <div class="container_third">
          <div class="carton_no">${content?.SNO || ""} (C)</div>
          <div class="third_main">
            <div class="third_one">
              <div class="third_1">${arrowSvg}</div>
              <div class="third_2">STACK<br />STAPELN</div>
              <div class="third_1">${arrowSvg}</div>
            </div>
            <div class="third_second">
              <table class="third_table">
                <tr>
                  <th colspan="3" style="font-size: 20px; padding-left: 2%; font-weight: bold; text-align: left;">LERROS MODEN GMBH</th>
                </tr>
                <tr>
                  <th id="third_data">CARTON NO.</th>
                  <th id="third_">:</th>
                  <th id="third_data1">${content?.SNO || ""}</th>
                </tr>
                <tr>
                  <th id="third_data">MEASUREMENT</th>
                  <th id="third_">:</th>
                  <th id="third_data1">${content ? carton_size : ""} CM</th>
                </tr>
                <tr>
                  <th id="third_data">N.W.</th>
                  <th id="third_">:</th>
                  <th id="third_data1">${content?.NetWt || ""} KGS</th>
                </tr>
                <tr>
                  <th id="third_data">G.W.</th>
                  <th id="third_">:</th>
                  <th id="third_data1">${content?.GrossWt || ""} KGS</th>
                </tr>
              </table>
            </div>
          </div>
          <div class="third_size">50cm</div>
          <div class="second_barcode">
            <div class="common-cell barcode-cell" id="barcode">${content?.svg || ""}</div>
          </div>
        </div>
        ${qrBlock}
      </div>

      <!-- (D) -->
      <div class="main_heading-container">
        ${detailBox("D", "40cm")}
        ${qrBlock}
      </div>

    </div>`;

  const htmlContent = `<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Galileo Carton Label</title>
    <style>
      .main_container {
        width: 676px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-direction: column;
        height: fit-content;
      }

      .main_heading-container {
        display: flex;
        justify-content: center;
        align-items: flex-end;      /* QR box sits at the bottom of the row */
        width: 80%;
      }

      .common-cell {
        display: flex;
        flex-direction: column;
        text-align: center;
        height: 15vh;
      }

      .barcode-cell {
        padding: 2% 0% 3% 2%;
      }

      /* ===== DETAIL BOX (A / D) ===== */
      .container_1_main {
        height: fit-content;
        width: 70%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }

      .container_1 {
        border: 2px solid black;
        width: 80%;
        padding: 2%;
      }

      .container_1_main_line {
        display: flex;
        width: 99.5%;
        justify-content: space-between;
        align-items: center;
      }

      #container_1_left_side {
        width: 70%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        text-transform: uppercase;
        font-size: 15px;
        font-weight: 600;
      }

      #container_1_middle_side {
        width: 5%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      #container_1_right_side {
        width: 45%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-transform: uppercase;
        text-align: center;
        font-size: 15px;
        font-weight: 600;
      }

      .container_1_main_line_2 {
        margin-top: 2%;
        margin-bottom: 1%;
      }

      .size_col {
        border: 2px solid black;
        text-align: center;
        width: 70px;
        height: 30px;
        padding: 1px;
      }

      .carton_no {
        height: 6vh;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        font-weight: bold;
        width: 100%;
      }

      /* ===== "50cm / 40cm" TEXT UNDER THE BOX ===== */
      /* Total height = 8 + 24 + 20 = 52px (QR is lifted by exactly this amount) */
      .third_size {
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        margin-top: 8px;
        margin-bottom: 20px;
        line-height: 24px;
      }

      /* ===== (B) STACK BOX ===== */
      .container_second {
        width: 70%;
        height: fit-content;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-top: 0.2%;
      }

      .container_second_ {
        display: flex;
        border: 2px solid black;
        width: 80%;
        height: 28vh;
        justify-content: center;
        align-items: center;
      }

      .second_left {
        font-size: 15px;
        width: 200px;
        height: 100px;
        margin: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .second_middle {
        box-sizing: border-box;
        width: 199%;
        min-height: 19vh;
        padding: 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        font-size: clamp(16px, 4vw, 32px);
        overflow-wrap: anywhere;
        line-height: 1.2;
        font-weight: bold;
      }

      /* ===== (C) INFO BOX ===== */
      .container_third {
        margin-top: 2%;
        width: 70%;
        height: 65vh;
        display: flex;
        align-items: center;
        flex-direction: column;
      }

      .third_main {
        border: 2px solid black;
        height: 65vh;
        width: 80%;
        display: flex;
        flex-direction: column;
        align-items: normal;
      }

      .third_one {
        height: 21vh;
        display: flex;
        width: 99%;
        justify-content: space-between;
        align-items: center;
      }

      .third_1 {
        width: 25%;
        font-size: 54px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .third_2 {
        width: 100%;
        font-size: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        font-weight: bold;
        padding: 1% 2%;
        overflow: clip;
      }

      .third_second {
        height: 7vh;
        text-align: center;
      }

      .third_table {
        width: 100%;
        margin-top: 0%;
      }

      #third_data {
        text-align: start;
        font-size: 15px;
        padding: 1% 1%;
        padding-left: 2%;
        width: 10%;
      }

      #third_ {
        width: 1%;
      }

      #third_data1 {
        font-size: 15px;
        padding: 0.5% 0.1%;
        width: 27%;
      }

      /* hidden barcode holders */
      .second_barcode {
        width: 100%;
        display: none;
      }

      /* ===== QR AREA ===== */
      .container_1_qr {
        display: flex;
        align-self: flex-end;       /* bottom aligned with the row */
        margin-left: 8px;
        flex-shrink: 0;
        margin-bottom: 52px;        /* = .third_size total height, so QR bottom == box bottom line */
      }

      .qr-main {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-start;    /* carton-id starts from QR's left edge */
        height: auto;
        width: fit-content;         /* width not fixed */
        min-width: 100px;
      }

      .carton-id {
        padding: 0 4px 10px 0;
        font-weight: 500;
        white-space: nowrap;
        width: fit-content;
        text-align: left;
      }

      .qr-code {
        width: 100px;
        height: 100px;
        display: block;
        object-fit: contain;
      }
    </style>
  </head>
  <body>
    <div class="tables-container">
      ${tbl}
    </div>
  </body>
</html>`;

  return (
    <div
      style={{
        width: 'auto',
        height: 'auto',
        overflow: 'visible',
        zoom: scale,
        padding: "100px",
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
};

export default PreviewGalileo;
